import React, { useEffect, useState, useRef } from "react";
import { Card, Col, Row, Table, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css'; 
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import { DEFAULTGROUPS } from "../../../shared/constants/Constants";
import { loadChatGroupDataRequest, loadGroupMessageGetDataRequest, loadGroupMessageAddDataRequest, clearGroupMessageData, loadChatImportDataRequest  } from "../redux/Actions";
import DefaultButton from "../../../shared/components/DefaultButton"; 

const DefaultGroups = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();    
    const employee = JSON.parse(localStorage.getItem("employee"));
    const fullName = `${employee.first_name} ${employee.last_name}`;   
    let [selectedRow, setSelectedRow] = useState({});
    const { chatgroup, message } = useSelector((state) => state.chatgroup);
    const [messageInput, setMessageInput] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    console.log("Chat Group Data:", employee);
    let [selectedForm, setSelectedForm] = useState(null);
    
    // Reference for the bottom of the message list
    const messagesEndRef = useRef(null);

    // Scroll to the bottom of the message list
    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "auto" }); // Instantly scroll to the bottom
        }
    };

    // Scroll to bottom whenever messages change
    useEffect(() => {
        scrollToBottom();
    }, [message]);
    
    useEffect(() => {
        return () => {
            dispatch(clearGroupMessageData()); // On component unmount
        };
    }, []);
    

    // Configure ReactQuill modules as needed
    const modules = {
        toolbar: [
            ['image'], // Only include the image option in the toolbar
        ],
    };
   
    useEffect(() => {
        if (employee.employee_id === '700006' || employee.employee_id === '135205') {
            dispatch(loadChatGroupDataRequest("auto"));
        } else {
            dispatch(loadChatGroupDataRequest('default'));
        }
    }, []);

    const getInitials = (name) => {
        const words = name.split(' ');
        return words.length > 1
            ? words[0][0] + words[1][0]
            : words[0].slice(0, 2);
    };

    const getColorFromName = (name) => {
        const colors = ['#3498db', '#e67e22', '#1abc9c', '#9b59b6', '#e74c3c', '#f39c12'];
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    };

    const htmlToPlainText = (html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
    
        // Replace <br> tags with \n
        let plainText = tempDiv.innerHTML.replace(/<br\s*\/?>/gi, "\n");
    
        // Replace block-level tags (like <p>) with \n
        plainText = plainText.replace(/<\/?p[^>]*>/gi, "\n");
    
        // Remove any remaining HTML tags
        plainText = plainText.replace(/<[^>]+>/g, "");
    
        // Normalize multiple consecutive line breaks to a single line break
        return plainText.replace(/(\r\n|\n|\r){2,}/g, "\n\n").trim();
    };

    const handleSendMessage = (event) => {
        event.preventDefault();  
         // Convert HTML content to plain text with \n line breaks   
        if (!messageInput.trim()) return; // Prevent sending empty messages  
           
        const normalizedMessage = htmlToPlainText(messageInput);
        let request= 
            {
                chatId: selectedRow.id,       
                content: normalizedMessage,          
                senderName: fullName     
            }; 
        dispatch(loadGroupMessageAddDataRequest(request));

        console.log("Sending message:", normalizedMessage, event);
        
        setMessageInput(""); 
    };

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
    
        const formData = new FormData();
        formData.append("file_upload", file);
        formData.append("chatId", selectedRow.id); 
        formData.append('form', selectedForm);
        try {           
            let request = {
                data: formData
            }
            dispatch(loadChatImportDataRequest(request));
        } catch (error) {
            console.error("Error uploading file:", error);
        }
    };

    const makeLinksClickable = (text) => {
        const urlRegex = /(https?:\/\/[^\s<]+)/g; // Regex to detect URLs, excluding `<br>` and other tags
        return text
            .replace(urlRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            })
            .replace(/<br\s*\/?>/gi, "<br>"); // Ensure <br> tags are preserved as line breaks
    };

    const hasChatAccess = (groupName) => {
        if (employee.role === 'admin') {
            return true; 
        }

        if (employee.employee_id === '700006') {
            return true; 
        }
        const groupAccess = employee.chat_access.find((access) => Object.keys(access)[0] === groupName);
        return groupAccess && groupAccess[groupName] === true;
    };

    const getFileNameFromFirebaseUrl = (url) => {
        try {          
          const encodedPath = url.split('/o/')[1].split('?')[0];   
          const decodedPath = decodeURIComponent(encodedPath); 
          const fileName = decodedPath.split('/').pop();
          return fileName;
        } catch (error) {
          console.error("Invalid URL format:", error);
          return null;
        }
      };

    return (
        <>
            <Row>
                <Col className="gx-0">
                    <Breadcrumbs
                        children={[
                            { href: '/', label: DEFAULTGROUPS },
                        ]}
                    />
                </Col>
            </Row>

            <Container fluid className="mt-3">
                <Row>
                    <Col md={12}>
                        <div style={{
                            display: 'flex',
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            padding: '0px',
                            alignItems: 'flex-start',
                            height: '600px',
                            gap: 0,
                            overflow: 'hidden',
                        }}>
                            {/* Table on the left */}
                            <div style={{ minWidth: '250px', height: '100%', padding: 0, margin: 0 }}>
                                <Card className="w-100" style={{ height: '100%', padding: 0, margin: 0, borderRadius: 0, border: "none" }}>
                                <div style={{ padding: '10px' }}>
                                        <input
                                            type="text"
                                            placeholder="Search groups..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                            }}
                                        />
                                </div>
                                    <Table
                                        bordered={false}
                                        hover
                                        responsive
                                        style={{ marginBottom: 0, borderColor: 'transparent' }}
                                        
                                    >
                                        <tbody>
                                            {chatgroup?.length > 0 ? (
                                                chatgroup.filter(group =>group.chat_name.toLowerCase().includes(searchTerm.toLowerCase()))                                                
                                                .map((group, index) => {
                                                    const lastMessageDate = group.lastMessageTime
                                                                            ? new Date(group.lastMessageTime).toLocaleDateString('en-US', {
                                                                                year: 'numeric',
                                                                                month: 'short',
                                                                                day: 'numeric',
                                                                            })
                                                                            : ''; 
                                                return (                        
                                                    <tr
                                                    key={group.id || index}
                                                    onClick={() => {
                                                        setSelectedRow(group);
                                                        dispatch(clearGroupMessageData());
                                                        dispatch(loadGroupMessageGetDataRequest(group.id));
                                                    }}
                                                    className="no-border"
                                                    style={{
                                                        cursor: 'pointer',
                                                        backgroundColor: selectedRow.id === group.id ? '#177978' : 'transparent',
                                                    }}
                                                >
                                                    <td style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' 
                                                        ,color: selectedRow.id === group.id ? 'white' : '#333',
                                                    }}>
                                                        {/* Group Icon */}
                                                        <div
                                                            style={{
                                                                width: '40px',
                                                                height: '40px',
                                                                borderRadius: '50%',
                                                                backgroundColor: getColorFromName(group.chat_name),
                                                                color: 'white',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontWeight: 'bold',
                                                                fontSize: '16px',
                                                                textTransform: 'uppercase',
                                                            }}
                                                        >
                                                            {getInitials(group.chat_name)}
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '280px' }}>                                                            
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <span style={{ fontWeight: 'bold', fontSize: '0.85rem', color: '#333' , marginTop: "5px", color: selectedRow.id === group.id ? 'white' : '#333'}}>
                                                                    {group.chat_name}
                                                                </span>
                                                                <span style={{ fontSize: '0.75rem', color: '#999', whiteSpace: 'nowrap' , marginTop: "5px", color: selectedRow.id === group.id ? 'white' : '#999'}}>
                                                                    {lastMessageDate}
                                                                </span>
                                                            </div>
                                                            <div dangerouslySetInnerHTML={{ __html: group.lastMessage }}
                                                                style={{
                                                                    fontSize: '0.85rem',
                                                                    color: selectedRow.id === group.id ? 'white' : '#555', 
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                }}
                                                            > 
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                );})
                                            ) : (
                                                <tr>
                                                    <td className="text-center">No groups found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Card>
                            </div>

                            {/* Message display area */}
                            <div style={{ flexGrow: 1, height: '100%' }}>
                                <Card className="w-100" style={{ height: '100%', padding: 0 }}>                                     
                                    <div
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            backgroundColor: '#f4f4f4',
                                            padding: '10px 20px',
                                            borderBottom: '1px solid #ddd',
                                            fontWeight: 'bold',
                                            fontSize: '1.2rem',
                                            zIndex: 1,
                                        }}
                                    >
                                        {selectedRow.chat_name || 'Select a Group'}
                                    </div>
                                    <Card.Body
                                        style={{
                                            overflowY: 'auto',
                                            height: 'calc(100% - 100px)', 
                                            padding: '20px'
                                        }}
                                    >                               
                                        {message && Object.keys(message).length > 0 ? (
                                            Object.entries(message).map(([date, messages]) => (
                                                <div key={date} style={{ marginBottom: '20px' }}>
                                                    
                                                    <div 
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginBottom: '20px',
                                                            position: 'relative'
                                                        }}>
                                                        <hr
                                                            style={{
                                                                flexGrow: 1,
                                                                border: 'none',
                                                                borderTop: '1px solid #ff7f0e',
                                                                margin: '0 10px',
                                                            }}
                                                        />
                                                        <span
                                                            style={{
                                                                backgroundColor: '#f4f4f4',
                                                                padding: '5px 15px',
                                                                borderRadius: '20px',
                                                                fontWeight: 'bold',
                                                                fontSize: '.75rem',
                                                                color: '#555',
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        >
                                                        {new Date(date).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: 'long',
                                                            day: 'numeric',
                                                        })}
                                                        </span>
                                                        <hr
                                                        style={{
                                                            flexGrow: 1,
                                                            border: 'none',
                                                            borderTop: '1px solid #ff7f0e',
                                                            margin: '0 10px',
                                                        }}
                                                    />
                                                    </div>
                                                    
                                                    {messages.map((msg, idx) => (
                                                        <div
                                                            key={idx}
                                                            style={{
                                                                marginBottom: '5px',
                                                                paddingBottom: '5px'
                                                            }}
                                                        >
                                                            <div>
                                                                <strong>
                                                                    {msg.senderName} {'@'}{msg.senderId}
                                                                    <span style={{ fontSize: '0.8rem', color: '#999', marginLeft: '10px' }}>
                                                                        {new Date(msg.timestamp).toLocaleTimeString()}
                                                                    </span>
                                                                </strong>
                                                            </div>
                                                            {msg.contentType === "image" ? (
                                                                <img
                                                                    src={msg.contentUrl[0]['fileUrl']}
                                                                    alt="Message Content"
                                                                    style={{
                                                                        width:'360px',
                                                                        maxWidth: '30%',
                                                                        height: 'auto',
                                                                        borderRadius: '5px',
                                                                        marginTop: '10px',
                                                                    }}
                                                                />
                                                            ) : msg.contentType === "file" ? (
                                                            <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                                                {/* File Icon */}
                                                                <i
                                                                    className="fas fa-file-alt"
                                                                    style={{
                                                                        fontSize: '1.2rem',
                                                                        color: '#007bff',
                                                                        marginRight: '8px',
                                                                    }}
                                                                ></i>

                                                                {/* File Name with Link */}
                                                                <a
                                                                    href={msg.contentUrl[0]['fileUrl']}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{
                                                                        textDecoration: 'none',
                                                                        color: '#007bff',
                                                                        fontWeight: 'bold',
                                                                        wordBreak: 'break-word', // Handle long file names
                                                                    }}
                                                                >
                                                                    {getFileNameFromFirebaseUrl(msg.contentUrl[0]['fileUrl']) }                            
                                                                </a>
                                                            </div>
                                                            ) : (
                                                            <div dangerouslySetInnerHTML={{
                                                                    __html: makeLinksClickable(msg.content.replace(/\n/g, "<br>")),
                                                                }}
                                                                style={{
                                                                    whiteSpace: "pre-wrap", // Preserve spaces and line breaks
                                                                    wordBreak: "break-word", // Handle long URLs
                                                                }}
                                                            ></div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            ))
                                        ) : (
                                            <p>No messages to display</p>
                                        )}
                                        <div ref={messagesEndRef} />
                                    </Card.Body>

                                    {/* Message Editor using ReactQuill */}
                                    {selectedRow.id && (
                                    <Card.Footer style={{ padding: '10px 20px', borderTop: '1px solid #ddd' }}>
                                        <div style={{ display: 'flex', alignItems: 'flex-end', 
                                           border: '1px solid #0a7674', 
                                           borderRadius: '5px', 
                                           backgroundColor: '#FFF',  
                                           flexGrow: 1, // Allow the parent div to grow
                                            maxHeight: '350px', // Set a maximum height for the parent div
                                            overflowY: 'auto', // Prevent overflow when the content exceeds max height
                                         }}>
                                            {/* <ReactQuill
                                                value={messageInput}
                                                onChange={(content) => setMessageInput(content)}
                                                modules={modules}  
                                                readOnly={employee.role !== 'admin' || employee.chat_access[selectedRow.chat_name] === true}                                             
                                                style={{ flexGrow: 1,
                                                    maxHeight: '250px', 
                                                    overflowY: 'auto', 
                                                    backgroundColor: !(employee.role === 'admin' || employee.chat_access[selectedRow.chat_name] === true) ? '#f5f5f5' : 'white',
                                                 }}
                                            /> */}

                                            <textarea
                                                    value={messageInput}
                                                    onChange={(e) => setMessageInput(e.target.value)}
                                                    onPaste={(e) => {
                                                        e.preventDefault(); 
                                                        const pastedData = e.clipboardData.getData('Text'); // Get pasted text
                                                        setMessageInput((prev) => prev + pastedData); // Append pasted content
                                                    }}
                                                    placeholder="Type your message here..."
                                                    style={{
                                                        flexGrow: 1,
                                                        // maxHeight: '350px',
                                                        // overflowY: 'auto',
                                                        padding: '10px',
                                                        borderRadius: '5px',
                                                        border: '0px solid #ddd',
                                                        resize: 'none',
                                                        backgroundColor: !hasChatAccess(selectedRow.chat_name)? '#f5f5f5' : 'white',
                                                        color: '#333',
                                                        outline: 'none',
                                                        boxShadow: 'none',
                                                    }}
                                                    disabled={!hasChatAccess(selectedRow.chat_name)}
                                            />
                                            <div style={{ marginRight: '3px', height:'44px', display: 'flex', alignItems: 'start' }}>
                                                <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                                                    <i className="fas fa-paperclip" style={{ fontSize: '1.5rem', color: '#0a7674' }}></i>
                                                </label>
                                                <input
                                                    id="file-upload"
                                                    type="file"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleFileUpload(e)}
                                                />
                                            </div>
     
                                            <DefaultButton
                                                buttonClass={`btn msg-btn ${
                                                    !hasChatAccess(selectedRow.chat_name) ? 'disabled' : ''
                                                }`}
                                                buttonTitle={<i className="fas fa-location-arrow"></i>}
                                                buttonType={"submit"}
                                                actionBlock={(event) => {
                                                    //if (!hasChatAccess(selectedRow.chat_name)) {
                                                        handleSendMessage(event);
                                                    //}
                                                }}
                                            />
                                        </div>
                                    </Card.Footer>
                                    )}
                                </Card>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default DefaultGroups;
